// src/components/dashboard/ActivityTimelineChart.tsx
import React from 'react';
import { CartesianGrid, Line, LineChart, XAxis } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from '../ui/chart';

const chartConfig = {
  count: { label: 'Agent Activity', color: 'var(--chart-2)' },
} satisfies ChartConfig;

interface ActivityTimelineChartProps {
  series: { date: string; count: number }[];
}

export const ActivityTimelineChart: React.FC<ActivityTimelineChartProps> = ({ series }) => {
  if (series.length === 0) {
    return <p className="text-sm text-brand-gray font-mono">No activity in this window yet.</p>;
  }

  return (
    <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
      <LineChart accessibilityLayer data={series}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="date" tickLine={false} axisLine={false} tickMargin={10} />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Line dataKey="count" stroke="var(--color-count)" strokeWidth={2} dot={false} />
      </LineChart>
    </ChartContainer>
  );
};